import "./App.css";
import Empezar from "./pages/Empezar";
import Home from "./pages/Home";
import Sintomas from "./pages/Sintomas";
import Tests from "./pages/Tests";
import Clinicas from "./pages/Clinicas";
import Navbar from "./components/Navbar/Navbar";
import { Routes, Route, useParams } from 'react-router-dom';
import Footer from "./components/Footer/Footer";
import TestDetalle from "./components/TestDetalle/TestDetalle"
import RequierePerfil from "./components/RequierePerfil/RequierePerfil";

// Layout para páginas con Navbar
const LayoutWithNavbar = ({ children }) => {
  return (
    <>
      <Navbar />
      {children}
      {/* <Footer /> */}
    </>
  );
};

// El key por testId fuerza a preguntar sexo y edad cada vez que se entra a un test
const TestDetalleConPerfil = () => {
  const { testId } = useParams();

  return (
    <RequierePerfil
      key={testId}
      navTarget="test_detalle"
      ubicacion="detalle_test"
    >
      <TestDetalle />
    </RequierePerfil>
  );
};

function App() {
  return (
    <>
    <Routes>
      {/* Home sin Navbar */}
      <Route path='/' element={<Home />} />
      
      {/* Páginas con Navbar */}
      <Route path='/empezar' element={
        <LayoutWithNavbar>
          <Empezar />
        </LayoutWithNavbar>
      } />
      <Route path='/sintomas' element={
        <LayoutWithNavbar>
          <Sintomas />
        </LayoutWithNavbar>
      } />
      <Route path='/tests' element={
        <LayoutWithNavbar>
          <Tests />
        </LayoutWithNavbar>
      } />
        {/* ✅ Ruta dinámica con Navbar */}
        <Route path='/tests/:testId' element={
          <LayoutWithNavbar>
            <TestDetalleConPerfil />
          </LayoutWithNavbar>
        } />
      <Route path='/clinicas' element={
        <LayoutWithNavbar>
          <Clinicas />
        </LayoutWithNavbar>
      } />
    </Routes>
    </>
  );
}

export default App;
